import React, { useState } from 'react';
import Review from './Review';
import Footer from './Footer';
import Logos from './Logos';

const PlaceOrderButton = () => {
  const [username, setuserName] = useState('');
  const [email, setEmail] = useState('');
  const [city, setCity] = useState('');
  const [contact, setContact] = useState('');
  const BASE_URL = 'https://node.insuranceadvisors.pk';


  // const handleSubmit = async (event) => {
  //   event.preventDefault();

  //   const orderData = { username, email, city, contact };

  //   try {
  //     // Save order data to the backend
  //     const saveResponse =  await fetch(`${BASE_URL}/api/savehealth`,  {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify(orderData),
  //     });

  //     if (saveResponse.ok) {
  //       // Send email with the saved order data
  //       const emailResponse = await fetch(`${BASE_URL}/api/sendHealthEmail`, {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //         body: JSON.stringify(orderData),
  //       });

  //       if (emailResponse.ok) {
  //         alert('Order placed and email sent successfully!');
  //         window.location.href = '/our';
  //       } else {
  //         console.error('Failed to send email:', emailResponse.statusText);
  //       }
  //     } else {
  //       console.error('Failed to submit data:', saveResponse.statusText);
  //     }
  //   } catch (error) {
  //     console.error('Error submitting data:', error);
  //   }
  // };

  const handleSubmit = async (event) => {
    event.preventDefault();
  
    const orderData = { username, email, city, contact };
  
    try {
      console.log("Sending data:", orderData);  // Log the request payload
  
      const saveResponse = await fetch(`${BASE_URL}/api/savehealth`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(orderData),
      });
  
      const saveResponseData = await saveResponse.json();
      console.log("Save response:", saveResponseData);
  
      if (saveResponse.ok) {
        // Send email
        const emailResponse = await fetch(`${BASE_URL}/api/sendHealthEmail`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(orderData),
        });
  
        const emailResponseData = await emailResponse.json();
        console.log("Email response:", emailResponseData);
  
        if (emailResponse.ok) {
          alert('Order placed and email sent successfully!');
          window.location.href = '/our';
        } else {
          console.error('Failed to send email:', emailResponse.status, emailResponseData);
        }
      } else {
        console.error('Failed to submit data:', saveResponse.status, saveResponseData);
      }
    } catch (error) {
      console.error('Error submitting data:', error);
    }
  };
  

  return (
    <div>

<div className="container-fluid trvl" style={{ marginBottom: '0', paddingBottom: '0' }}>
  <h5>
    <marquee>LIMITED TIME OFFER...Offering upto 10% discount on Health Insurance.</marquee>
  </h5>
</div>

      <div className="container col-12" style={{ marginTop: '0', paddingTop: '0' }}>
        <div className="row">
        <div className="col-12 col-sm-6 px-0 px-sm-3 order-0 order-sm-1"  style={{
        marginTop: '10px',
        paddingTop: '0',
      }}>
  <div className="d-none d-sm-block"> {/* Hides on small screens */}
    <br /><br /><br /><br /> 
    </div>
  {/* <br />These will still appear on all screen sizes */}
  <img src="./assets/img/health.png" className="img-fluid" alt="Health Insurance" />
</div>

          <div className="col-sm-6 ">
            {/* Heading section, centered on mobile view */}
    <div className="col-12 order-1 order-sm-0 text-center mb-3">
      <div className="card-heading">
        <h4 className="title">Health Insurance Form</h4>
        <p id="p_1" className="d-block d-sm-none">Are you concerned about your health?</p>
        <p id="p_1" className="d-block d-sm-none">Feel Free to Contact Us!</p>
      </div>
    </div>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="name">Full name</div>
                  <div className="value">
                    <input
                      className="input--style-6 form-control"
                      type="text"
                      name="username"
                      value={username}
                      onChange={(e) => setuserName(e.target.value)}
                      placeholder="Enter your Full Name"
                      required
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="name">Email address</div>
                  <div className="value">
                    <input
                      className="input--style-6 form-control"
                      type="email"
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="example@email.com"
                      required
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="name">Contact Number</div>
                  <div className="value">
                    <input
                      className="input--style-6 form-control"
                      type="number"
                      name="contact"
                      value={contact}
                      onChange={(e) => setContact(e.target.value)}
                      placeholder="0321**"
                      required
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="name">Enter Your City</div>
                  <div className="value">
                    <input
                      className="input--style-6 form-control"
                      type="text"
                      name="city"
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                      placeholder="Enter your City Name"
                      required
                    />
                  </div>
                </div>
                <br/>
                <div className="cl1 text-center">
                  <button className="btn btn-danger" type="submit">Confirm Order</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <br /><br />
      <Logos></Logos>

      {/*  */}

      <Review />
      <br></br>
      {/* *************************************** */}
     
<div id="ss">
      <div class="insurance-wrapper">
    <h2>TYPES OF HEALTH INSURANCE</h2>
    <p class="subheading">Stay secure with our comprehensive health insurance policies designed to protect you and your loved ones at every step.</p>
    
    <div class="cards-wrapper">
        <div class="insurance-card">
            <div class="card-icon"><i class="fas fa-user-shield"></i></div>
            <h3>Individual Health Insurance</h3>
            <p>"Safeguard your health with our Individual Health Insurance. Tailored to meet your specific needs, this plan offers comprehensive medical coverage for individuals."</p>
        </div>
        <div class="insurance-card">
            <div class="card-icon"><i class="fas fa-users"></i></div>
            <h3>Family Health Insurance</h3>
            <p>"Cover your entire family under one plan. Our Family Health Insurance ensures everyone receives the best medical care, giving you peace of mind."</p>
        </div>
        <div class="insurance-card">
            <div class="card-icon"><i class="fas fa-hospital"></i></div>
            <h3>Critical Illness Insurance</h3>
            <p>"Stay financially secure during challenging times with our Critical Illness Insurance. Covers major illnesses like cancer, stroke, and more."</p>
        </div>
    </div>
</div>
</div>


      <br /><br />
      <Footer />
    </div>
  );
};

export default PlaceOrderButton;
